import { http } from "@/helpers/http";
import APP_URL from "@/helpers/urls";

const baseURL = APP_URL("notifications");

export default {
  namespaced: true,

  actions: {

    fetchNotifications({ state, commit, rootState }, payload) {
      http.get(baseURL, payload.data)
        .then(response => {
          if (payload.callback) payload.callback(true, response.data);
        })
        .catch(error => {
          if (payload.callback) payload.callback(false);
        })
    },

    readNotificaiton({ state, commit, rootState }, payload) {
      http.post(baseURL + "/" + payload.id + "/read")
        .then(response => {
          if (payload.callback) payload.callback(true, response.data);
        })
        .catch(error => {
          if (payload.callback) payload.callback(false);
        })
    },

    async readNotificationAsync({ state, commit, rootState }, payload) {
      try {
        const { data } = await http.post(baseURL + "/read", {
          id: payload.id,
          createdAt: payload.createdAt
        })
        return data
      } catch (e) {
        console.log(e)
        return false
      }

    }
  },
};
